import { Logout } from '../api'
import PlatformAuth from 'aldoo-ra/PlatformAuth'
import Value from 'aldoo-ra/Value'
import config from 'aldoo-ra/Config'

// Shared function to clear all user-related localStorage data
export const clearUserLocalStorage = () => {
    if (typeof window === "undefined") return

    // Clear user profile
    localStorage.removeItem("user-profile")

    // Clear user credentials (uses app-specific key)
    const userCredentialsKey = config.APP_NAME.toLowerCase().replace(" ", "-") + "-ck"
    localStorage.removeItem(userCredentialsKey)

    // Clear store/cart data (user-specific)
    localStorage.removeItem("aldoo-store-cart")
    localStorage.removeItem("aldoo-payment-info")
    localStorage.removeItem("aldoo-promo-code-info")
    localStorage.removeItem("aldoo-promo-code")
    localStorage.removeItem("aldoo-payment-receipt")
}

const useLogout = () => {
    //currently logged in user credentials
    const [, setAuth] = PlatformAuth.useAuth()
    const [, setProfile] = Value("user-profile")

    return async () => {
        try {
            //logout the user
            const response = await Logout()

            // Clear local state and storage on successful logout OR invalid_device error
            if (response.result || response.error === 'invalid_device') {
                //reset the user credentials
                setAuth(null)
                setProfile(null)

                // Clear localStorage data when device is invalid
                if (response.error === 'invalid_device') {
                    clearUserLocalStorage()
                }
            }
        } catch (error) {
            // If logout API fails completely, still clear local state
            setAuth(null)
            setProfile(null)
        }
    }
}

export default useLogout